module.exports = __webpack_public_path__ + "static/media/tips-icon.de425749.jpg";